/*
  Bothanica Mineral — Reveal de pétalas por seção.

  - Carrega GSAP + ScrollTrigger sob demanda (mesma CDN do bm-scroll-decor, então
    o script já vem cacheado quando ambos estão na página). Não bloqueia o LCP.
  - Cada grupo [data-bmpr] revela suas pétalas "caindo" com leve rotação e stagger
    quando entra no viewport; reverte ao sair por cima (toggleActions).
    NÃO há loop contínuo — zero custo de CPU quando a seção está fora de tela.
  - Respeita prefers-reduced-motion: mostra as pétalas estáticas no repouso.
  - Idempotente e com falha silenciosa (sem GSAP, mostra estado base).
*/
(function () {
  if (window.__bmPetalRevealInit) return;
  window.__bmPetalRevealInit = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function petalsOf(node) {
    return Array.prototype.slice.call(node.querySelectorAll('.bmpr__petal'));
  }

  function restState(petal) {
    var o = parseFloat(petal.getAttribute('data-o') || '0.5');
    petal.style.setProperty('--bmpr-target-o', o);
    return {
      o: o,
      rot: parseFloat(petal.getAttribute('data-rot') || '0')
    };
  }

  function revealStatic(node) {
    petalsOf(node).forEach(function (p) {
      var s = restState(p);
      p.style.opacity = s.o;
      p.style.transform = 'rotate(' + s.rot + 'deg)';
    });
  }

  function start() {
    var nodes = document.querySelectorAll('[data-bmpr]');
    if (!nodes.length) return;

    if (prefersReduced) {
      Array.prototype.forEach.call(nodes, revealStatic);
      return;
    }

    loadGsap(function (ok) {
      if (!ok || !window.gsap || !window.ScrollTrigger) {
        Array.prototype.forEach.call(nodes, revealStatic);
        return;
      }
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      Array.prototype.forEach.call(nodes, function (node) {
        if (node.__bmprDone) return;
        node.__bmprDone = true;

        var petals = petalsOf(node);
        if (!petals.length) return;

        var fall = parseInt(node.getAttribute('data-bmpr-fall') || '90', 10);

        // Estado inicial: mais alto, menor, girado e transparente (pronto p/ cair).
        petals.forEach(function (p, i) {
          var s = restState(p);
          // Variação determinística por índice para a queda não ficar uniforme.
          var dx = (i % 2 === 0 ? -1 : 1) * (10 + (i % 3) * 8);
          gsap.set(p, {
            autoAlpha: 0,
            x: dx,
            y: -(fall + (i % 4) * 22),
            scale: 0.6,
            rotation: s.rot - 26
          });
        });

        // Timeline única revelada na entrada da seção (toggleActions, sem scrub).
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: node,
            // O bloco tem altura ~0 e as pétalas sangram p/ cima; disparamos quando
            // o limite entre seções sobe até ~82% da viewport.
            start: 'top 82%',
            toggleActions: 'play none none reverse'
          }
        });

        tl.to(petals, {
          autoAlpha: function (i, t) {
            return parseFloat(t.getAttribute('data-o') || '0.5');
          },
          x: 0,
          y: 0,
          scale: 1,
          rotation: function (i, t) {
            return parseFloat(t.getAttribute('data-rot') || '0');
          },
          duration: 1.0,
          ease: 'power3.out',
          stagger: 0.07
        });
      });
    });
  }

  function loadGsap(cb) {
    if (window.gsap && window.ScrollTrigger) return cb(true);

    var core = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var st =
      'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    inject(core, function (okCore) {
      if (!okCore) return cb(false);
      inject(st, function (okSt) {
        cb(okSt);
      });
    });
  }

  function inject(src, done) {
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.loaded === 'true') return done(true);
      existing.addEventListener('load', function () {
        done(true);
      });
      existing.addEventListener('error', function () {
        done(false);
      });
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      s.dataset.loaded = 'true';
      done(true);
    };
    s.onerror = function () {
      done(false);
    };
    document.head.appendChild(s);
  }

  // Dispara start() apenas quando uma seção [data-bmpr] se aproxima da viewport,
  // evitando baixar o GSAP no window.load para quem nunca rola até as decorações.
  // Mantém o comportamento anterior em reduced-motion e em navegadores sem IO.
  function boot() {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      start();
      return;
    }

    var nodes = document.querySelectorAll('[data-bmpr]');
    if (!nodes.length) return;

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          obs.disconnect();
          start();
          return;
        }
      }
    }, { rootMargin: '400px 0px' });

    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }
})();
